import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {getObjectFromArrayOfObjects} from "../../../../_helpers/helperFunctions";
import {getOptionsByData, isEmpty} from "../../../../_helpers/commonFunctions";
import {fetchAdvancedTypes, fetchBankAccounts, fetchPOS, fetchSalesGeneralSettings} from "../../../../_apis/api";
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import pdfToText from "react-pdftotext";
import moment from "moment";
import {
    setEmronClientPaymentsRequestData,
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {toast} from "react-toastify";
import axios from "axios";
import Alert from "react-bootstrap/Alert";
import Dropdown from "../../../primer/Dropdown";
import {preNumberGreek} from "../../../../_data/settings/advanced-types-search";
import DateBox from "../../../primer/DateBox";

const EmronClientPayments = () => {
    const dispatch = useDispatch();
    const requestData = useSelector((state) => state.SALES.emronClientPaymentsRequestData);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const SETTINGS = useSelector((state) => state.SETTINGS);
    const SALES_SETTINGS = useSelector((state) => state.SALES_SETTINGS);
    const CASH_DATA = useSelector((state) => state.CASH_DATA);
    const [loadStatuses, setLoadStatuses] = useState(false);
    const [loading, setLoading] = useState(false);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const allDocumentTypes = SETTINGS.settings.advancedTypes;
    const clientPaymentsDT = getObjectFromArrayOfObjects(allDocumentTypes.filter((el) => el.myDataType !== "8.4" && el.myDataType !== "8.5"), "Client Payments", "section");
    const documentTypesOptions = getOptionsByData(clientPaymentsDT, "_id", "name");
    const paymentTypeOptions = getOptionsByData(SALES_SETTINGS.salesGeneralSettings.paymentTypes?.filter((el) => el.type !== "credit"), "_id", "name");

    const posOptions = getOptionsByData(CASH_DATA.posList, '_id', 'name');
    const bankOptions = getOptionsByData(CASH_DATA.bankAccounts, '_id', 'name');

    useEffect(() => {
        dispatch(fetchAdvancedTypes({company: company.id}));
        dispatch(fetchSalesGeneralSettings({company: company.id}));
        dispatch(fetchPOS({company: company.id}));
        dispatch(fetchBankAccounts({company: company.id}));
    }, [])

    useEffect(() => {
        if (loadStatuses) {
            setLoadStatuses(false);
            getStatuses();
        }
    }, [loadStatuses]);

    const getStatuses = async () => {
        const cps = requestData.clientPaymentsData;
        if (cps.length > 0) {
            setLoading(true);
            let tNums = [];
            for (let cp of cps) {
                tNums.push(String(cp.transactionNumber));
            }
            try {
                const serverResponse = await axios.post(process.env.REACT_APP_API_URL2 + "/client/emron-client-payments-statuses",  {
                    company: company.id,
                    year: company.year,
                    transactionNumbers: tNums,
                }, {
                    headers: { "Content-Type": "application/json" },
                })
                if (serverResponse.data.status === "200") {
                    let cloneCPs = structuredClone(requestData.clientPaymentsData);
                    for (let key in serverResponse.data.data) {
                        cloneCPs.find((el) => String(el.transactionNumber) === String(key)).status = serverResponse.data.data[key];
                    }
                    dispatch(setEmronClientPaymentsRequestData({...requestData, clientPaymentsData: cloneCPs}));
                    setLoading(false);
                } else {
                    toast.error(serverResponse.data.message);
                    setLoading(false);
                }
            } catch (error) {
                setLoading(false);
                console.log(error);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            }
        }
    }

    const handleCreateClientPayments = () => {
        const cps = requestData.clientPaymentsData;
        if (!requestData.date || !moment(requestData.date, "DD/MM/YYYY").isValid()) {
            return toast.error("Παρακαλώ συμπληρώστε ημέρα τραπεζικού εμβάσματος.");
        }
        if (cps.length > 0) {
            setLoading(true);
            let tNums = [];
            for (let cp of cps) {
                tNums.push(String(cp.transactionNumber));
            }
            axios.post(process.env.REACT_APP_API_URL2 + "/client/emron-clients-payments-create", {...requestData, company: company.id, year: company.year, transactionNumbers: tNums}, {
                headers: { "Content-Type": "application/json" },
            }).then((res) => {
                setLoading(false);
                if (res.data.status === "200") {
                    if (res.data.count === 0) {
                        toast.info("Δεν δημιουργήθηκε καμία είσπραξη.");
                    } else {
                        toast.success(`${res.data.count} ${res.data.count === 1 ? "είσπραξη δημιουργήθηκε" : "εισπράξεις δημιουργήθηκαν"} επιτυχώς.`);
                    }
                    setShowCreateModal(false);
                    setLoadStatuses(true);
                } else {
                    toast.error(res.data.message);
                }
            }).catch((err) => {
                setLoading(false);
                console.log(err);
                toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
            })
        }
    }

    const handleOnChange = (e, type, name) => {
        if (type === "file" && name === "file") {
            const selectedFile = e.target.files[0];
            pdfToText(selectedFile).then((data) => {
                if (!isEmpty(data)) {
                    let extraInfoJSON = {}
                    const regex = /Πακέτο: \s*(\d+)/;
                    let packet = data.match(regex);
                    if (packet && packet.length > 1) extraInfoJSON["Πακέτο"] = packet[1];

                    const aaType = data.includes("Α/  Α") ? "Α/  Α" : data.includes("Α/ Α") ? "Α/ Α" : "Α/Α";

                    let extraInfo = data.split(aaType)[0];
                    extraInfo = extraInfo.split("Σύνολα")[1];
                    extraInfo = extraInfo.replace(/ {3}/g, " ");
                    extraInfo = extraInfo.replace(/ {2}/g, "|");
                    let ex = extraInfo.split("|");
                    for (let str of ex) {
                        let split = String(str).split(":");
                        if (split && split[0] && split[1]) extraInfoJSON[split[0]] = String(split[1]).trim();
                    }

                    let tableContents = data.split(aaType)[1];
                    const eisPosType = data.includes("Εισπρακτέο  ποσό") ? "Εισπρακτέο  ποσό" : "Εισπρακτέο ποσό";
                    tableContents = String(tableContents.split(eisPosType)[1]).trim();
                    tableContents = tableContents.replace(/ {3}/g, "|");
                    let rows = tableContents.split(/ {2}/g);
                    // Look for new page
                    let cloneRows = [];
                    for (let row of rows) {
                        const split = row.split("|")
                        if (split.length > 14) {
                            const lastCell = row.split("|")[12];
                            const commaIdx = lastCell.indexOf(",");
                            const rowNum = lastCell.slice(commaIdx + 3);
                            cloneRows.push(`${split.slice(0, 12).join("|")}|${lastCell.slice(0, commaIdx + 3)}`);
                            cloneRows.push(`${rowNum}|${split.slice(13).join("|")}`);
                        } else {
                            cloneRows.push(row);
                        }
                    }
                    rows = cloneRows.filter((el) => el !== "Εκτύπωση|Επιστροφή");
                    let jsonRows = [];
                    for (let row of rows) {
                        const arrRow = row.split("|");
                        let date = moment(String(arrRow[1]), "DD/MM/YY HH:mm");
                        if (String(arrRow[1]).includes("μμ")) date = date.add(12, "hours");
                        jsonRows.push({
                            no: arrRow[0],
                            date: date.format("DD/MM/YYYY HH:mm"),
                            orderId: String(arrRow[3]).split("-")[0],
                            transactionNumber: arrRow[4],
                            amount: parseFloat(String(arrRow[6]).replaceAll(".", "").replaceAll(",", ".")),
                            status: "loading",
                        })
                    }
                    dispatch(setEmronClientPaymentsRequestData({...requestData, clientPaymentsData: jsonRows, extraInfo: extraInfoJSON}));
                    e.target.value = "";
                    setLoadStatuses(true);
                }
            }).catch((err) => {
                e.target.value = "";
                toast.error("Σφάλμα κατά την ανάγνωση εγγράφου");
                console.log(err);
            })
        } else if (type === "dropdown") {
            if (name === "paymentType") {
                const paymentObjArr = SALES_SETTINGS.salesGeneralSettings.paymentTypes.find((el) => el._id === e.value);
                if (paymentObjArr) {
                    dispatch(setEmronClientPaymentsRequestData({...requestData, paymentType : e.value, paymentTypeType: paymentObjArr.type, bankOrPOS: ""}));
                }
            } else {
                dispatch(setEmronClientPaymentsRequestData({...requestData, [name] : e.value}));
            }
        } else if (type === "datebox") {
            if (moment(e).isValid()) {
                dispatch(setEmronClientPaymentsRequestData({...requestData, [name] : moment(e).format("DD/MM/YYYY")}));
            } else {
                dispatch(setEmronClientPaymentsRequestData({...requestData, [name] : ""}));
            }
        }
    }

    const getStatus = (status) => {
        if (status === "loading") {
            return <Badge style={{fontSize: "12px"}} bg={"primary"}>Γίνεται συσχέτιση...</Badge>
        } else if (status.startsWith("already")) {
            return <Badge style={{fontSize: "12px"}} bg={"primary"}>Η είσπραξη έχει περαστεί ήδη</Badge>
        } else if (status.startsWith("okSale")) {
            const split = status.split("|");
            const clientName = split[1];
            const clientVATNumber = split[2];
            const saleDocument = split[3];
            return (
                <React.Fragment>
                    <Badge style={{fontSize: "12px"}} bg={"success"}>
                        Βρέθηκε παραστατικό προς εξόφληση
                    </Badge>
                    <br/>
                    <strong>Πελάτης:</strong> {clientName}<br/>
                    <strong>ΑΦΜ:</strong> {clientVATNumber}<br/>
                    <strong>Παραστατικό:</strong> {saleDocument}
                </React.Fragment>
            )
        } else if (status.startsWith("semiSettlement") || status.startsWith("okSettlement")) {
            const split = status.split("|");
            const clientName = split[1];
            const clientVATNumber = split[2];
            const datePaid = moment(split[3]).format("DD/MM/YYYY HH:mm:ss");
            const totalPaid = split[4];
            const settlementAmount = split[5];
            let settlementProblem = false;
            if (Number(totalPaid) !== Number(settlementAmount)) {
                settlementProblem = true;
            }
            return (
                <React.Fragment>
                    <hr style={{margin: "2px"}} />
                    {settlementProblem ? (
                        <Badge className={"mt-1"} style={{fontSize: "12px"}} bg={"danger"}>Προσοχή: Δεν συμφωνούν τα ποσά την πληρωμής και της αντίστοιχης δόσης!</Badge>
                    ) : (
                        <Badge bg={"success"} style={{fontSize: "12px"}}>Βρέθηκε δόση διακανονισμού προς εξόφληση</Badge>
                    )}
                    <br/>
                    <strong>Πελάτης:</strong> {clientName}<br/>
                    <strong>ΑΦΜ:</strong> {clientVATNumber}<br/>
                    <strong>Ημ/νια Πληρωμής</strong> {datePaid}<br/>
                    <strong>Ποσό Πληρωμής:</strong> {totalPaid}<br/>
                    <strong>Ποσό Δόσης Διακανονισμού:</strong> {settlementAmount}<br/>
                </React.Fragment>
            )
        } else if (status === "error") {
            return <Badge style={{fontSize: "12px"}} bg={"danger"}>Δεν βρέθηκε τρόπος συσχέτισης</Badge>
        } else if (status.startsWith("badSettlement")) {
            const split = status.split("|");
            const clientName = split[1];
            const clientVATNumber = split[2];
            return <Badge style={{fontSize: "12px"}} bg={"danger"}>Αφορά τον διακανονισμό του<br/>
                Πελάτη: {clientName}<br/>
                ΑΦΜ: {clientVATNumber}<br/>
                αλλά δεν αντιστοιχεί η ημερομηνία σε κάποια ημερομηνία δόσης.</Badge>
        }
    }

    const invalidCreation = () => {
        return isEmpty(requestData.documentType) || isEmpty(requestData.preNumber) || isEmpty(requestData.paymentType)
            || (requestData.paymentTypeType === "bank-account" && isEmpty(requestData.bankOrPOS))
            || (requestData.paymentTypeType === "pos" && isEmpty(requestData.bankOrPOS));
    }

    const amountsEqual = () => {
        const incomingAmount = String(requestData.extraInfo["Εισπρακτέο ποσό"]).replaceAll(".", "").replace(",", ".");
        const feeAmount = String(requestData.extraInfo["Ποσό προμήθειας"]).replaceAll(".", "").replace(",", ".");
        let totalCPs = 0;
        const cps = requestData.clientPaymentsData;
        for (let cp of cps) {
            totalCPs += cp.amount;
        }
        totalCPs = Number(Number(totalCPs).toFixed(2));
        let pseudoInc = Number(Number(Number(incomingAmount) + Number(feeAmount)).toFixed(2));
        return [totalCPs === pseudoInc, totalCPs, pseudoInc];
    }

    const handleBankDateChange = () => {
        const tNums = requestData.clientPaymentsData?.flatMap((o) => o.transactionNumber);
        axios.post(`${process.env.REACT_APP_API_URL2}/client/emron-cps-bank-date`, {
            date: requestData.date,
            tNums: tNums,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success("Επιτυχής ενέργεια.");
                getStatuses();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    return (
        <div hidden={company.vatNumber !== "800434990"}>
            <Row>
                <Col md={3}>
                    <div className={"text-muted mb-1"}><i>Επιλέξτε αρχείο</i></div>
                    <input
                        type="file"
                        className="form-control"
                        accept="application/pdf"
                        style={{lineHeight: "1.75"}}
                        onChange={(e) => handleOnChange(e, "file", "file")}
                        disabled={loading}
                    />
                </Col>
                {loading && (
                    <Col md={3}>
                        <div style={{marginTop: "30px"}}>Γίνεται συσχέτιση παρακαλώ περιμένετε...</div>
                    </Col>
                )}
                <Col md={3}>
                    <DateBox
                        name="date"
                        selected={isEmpty(requestData.date) ? moment().toDate() : moment(requestData.date, "DD/MM/YYYY").toDate()}
                        label={"Ημερομηνία τραπεζικού εμβάσματος"}
                        onChange={(e) => handleOnChange(e, "datebox", "date")}
                    />
                    <Button className={"mt-2"} size={"sm"} onClick={() => handleBankDateChange()}>Εφαρμογή ημερομηνίας τραπεζικού εμβάσματος στις υπάρχουσες εισπράξεις</Button>
                </Col>
            </Row>
            {requestData?.clientPaymentsData?.length > 0 && (
                <React.Fragment>
                    <hr/>
                    <Alert variant={"secondary"} className={"mb-1"}>
                        Μία είσπραξη δεν δημιουργείται αν ισχύει τουλάχιστον μία από τις παρακάτω περιπτώσεις: <br/>
                        - Το αντίστοιχο παραστατικό δεν βρεθεί ή αν δεν βρεθεί αντίστοιχη δόση διακανονισμού <br/>
                        - Η είσπραξη έχει περαστεί ήδη στο σύστημα <br/>
                        Η διαδικασία της δημιουργίας εισπράξεων θα δημιουργήσει εισπράξεις που ΔΕΝ έχουν κάποιο από τα
                        παραπάνω κριτήρια
                    </Alert>
                    {Object.keys(requestData.extraInfo).length > 0 && (
                        <Row className={"mb-2"}>
                            <div className={"text-muted mb-1"}><i>Πληροφορίες Πακέτου</i></div>
                            <Col md={3}>
                                <div style={{
                                    border: "2px solid #6ea2a9",
                                    borderRadius: "5px",
                                    padding: "5px",
                                    fontSize: "14px"
                                }}>
                                    {Object.keys(requestData.extraInfo).map((key) => (
                                        <React.Fragment>
                                            <strong>{key}</strong>: {requestData.extraInfo[key]}<br/>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </Col>
                            {!amountsEqual()[0] && (
                                <Col md={3}>
                                    <div style={{color: "red", fontWeight: "600"}}>ΠΡΟΣΟΧΗ ΤΑ ΠΟΣΑ ΔΕΝ ΣΥΜΦΩΝΟΥΝ (ΕΝΤΟΠΙΣΜΕΝΟ ΣΥΝΟΛΟ {amountsEqual()[1]} ΕΝΑΝΤΙ ΣΥΝΟΛΟ ΠΑΚΕΤΟΥ {amountsEqual()[2]})</div>
                                </Col>
                            )}
                        </Row>
                    )}
                    <div className={"text-muted mb-1"}><i>Εντοπισμένες Συναλλαγές</i></div>
                    <Row>
                        {requestData?.clientPaymentsData.map((row) => (
                            <Col md={4} className={"mb-2"}>
                                <div style={{border: "2px solid #6ea2a9", borderRadius: "5px", padding: "5px", fontSize: "14px"}}>
                                    <strong>Α/Α:</strong> {row.no}<br/>
                                    <strong>Ημερομηνία:</strong> {row.date}<br/>
                                    <strong>Αρ. Συναλλαγής:</strong> {row.transactionNumber}<br/>
                                    <strong>Ποσό</strong> {row.amount}<br/>
                                    {getStatus(row.status)}
                                </div>
                            </Col>
                        ))}
                    </Row>
                    <Row className={"mt-3"}>
                        <Col md={6}>
                            <Button onClick={() => getStatuses()} className={"mr-3"}>Ανανέωση καταστάσεων</Button>
                            {requestData.clientPaymentsData?.filter((el) => String(el.status).startsWith("ok")).length > 0 && (
                                <Button onClick={() => setShowCreateModal(true)}>Δημιουργία Εισπράξεων</Button>
                            )}
                        </Col>
                    </Row>
                    <Modal backdrop={"static"} show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Δημιουργία Εισπράξεων</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <i>Παρακαλώ επιλέξτε τις ρυθμίσεις που επιθυμείτε παρακάτω.</i>
                            <Dropdown
                                name={"documentType"}
                                label={"Τύπος Παραστατικού"}
                                className={"mt-2 mb-3"}
                                options={documentTypesOptions}
                                key={Math.random()}
                                required={true}
                                defaultValue={documentTypesOptions?.find((el) => el.value === requestData.documentType)}
                                onChange={(e) => handleOnChange(e, "dropdown", "documentType")}
                            />
                            <Dropdown
                                name={"preNumber"}
                                label={"Σειρά"}
                                className={"mb-3"}
                                options={preNumberGreek}
                                key={Math.random()}
                                required={true}
                                defaultValue={preNumberGreek?.find((el) => el.value === requestData.preNumber)}
                                onChange={(e) => handleOnChange(e, "dropdown", "preNumber")}
                            />
                            <Dropdown
                                name={"paymentType"}
                                label={"Τρόπος Πληρωμής"}
                                className={"mb-3"}
                                options={paymentTypeOptions}
                                key={Math.random()}
                                required={true}
                                defaultValue={paymentTypeOptions?.find((el) => el.value === requestData.paymentType)}
                                onChange={(e) => handleOnChange(e, "dropdown", "paymentType")}
                            />
                            {(requestData.paymentTypeType === "bank-account" || requestData.paymentTypeType === "pos") && (
                                <Dropdown
                                    name={"bankOrPOS"}
                                    label={requestData.paymentTypeType === "bank-account" ? "Τραπεζικός Λογαριασμός" : "POS"}
                                    className={"mb-3"}
                                    options={requestData.paymentTypeType === "bank-account" ? bankOptions : posOptions}
                                    key={Math.random()}
                                    required={true}
                                    defaultValue={requestData.paymentTypeType === "bank-account" ? bankOptions.find((el) => el.value === requestData.bankOrPOS) : posOptions.find((el) => el.value === requestData.bankOrPOS)}
                                    onChange={(e) => handleOnChange(e, "dropdown", "bankOrPOS")}
                                />
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="outline-primary" onClick={() => setShowCreateModal(false)}>
                                Κλείσιμο
                            </Button>
                            <Button variant="primary" onClick={() => handleCreateClientPayments()} disabled={invalidCreation() || loading}>
                                Δημιουργία Εισπράξεων {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                            </Button>
                        </Modal.Footer>
                    </Modal>
                </React.Fragment>
            )}
        </div>
    )
}

export default EmronClientPayments